<template>
  <div class="container">
    <QueryFrame
    :addText="handlePermission('roleAdd')?'新建角色':''"
    @handlePage='handlePage'
    @handlePageSize='handlePageSize'
    @addNew='addNew'
    :count= 'count'
    :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>角色名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.name'></lk-input>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.createUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  placeholder="请选择" class="item" v-model.trim='query.createTime'
            :options='createTimeOption'
            ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>最后修改时间:</label>
            <timeStampDatePicker  placeholder="请选择" class="item" v-model.trim='query.modifiedTime'  :options='modifiedTimeOption'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
    <DTPModal
      v-model="showEdit"
      @confirm='confirmEdit'
      content='一旦编辑，则影响所有使用相应角色的门店，慎用！'
      ></DTPModal>
  </div>
</template>
<script>

import QueryFrame from '@/components/frame/QueryFrame.vue';
import system from '@/services/system';
import utils from '@/libs/utils';
import DTPModal from '@/components/DTPModal.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'roleList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DTPModal,
  },
  data() {
    return {
      toEditId: 0,
      showEdit: false,
      query: {
        name: '',
        createUserName: '',
        createTime: null,
        modifiedTime: null,
      },
      createTimeOption: this.createDate(),
      modifiedTimeOption: this.modifiedDate(),
      columns: [
        { title: '角色ID', key: 'id', minWidth: 116 },
        { title: '角色名称', key: 'name', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '最后修改时间', key: 'modifiedTime', minWidth: 116 },
        { title: '修改人', key: 'modifiedUserName', minWidth: 116 },
        { title: '角色类型', key: 'type', minWidth: 116 },
        {
          title: '状态',
          key: 'status',
          minWidth: 116,
          render: (h, params) => {
            const id = params.row.id;
            const disabled = id <= 2000;

            return this.handlePermission('roleEnableDisable') ? h('lk-switch', {
              props: {
                size: 'large',
                value: params.row.status === 1,
                loading: params.row.loading,
                disabled,
              },
              on: {
                'on-change': (flag) => {
                  params.row.loading = false;
                  const toggleFunction = flag ? system.roleEnable : system.roleDisable;
                  const Message = flag ? '该角色已启用' : '该角色已禁用';
                  const data = {
                    sysRole: {
                      id: params.row.id,
                    },
                  };
                  toggleFunction(data).then((res) => {
                    if (res.data.status === 200) {
                      this.$Message.success(Message);
                      params.row.loading = false;
                    } else {
                      params.row.loading = false;
                      this.$Message.error(res.data.error);
                      this.getData();
                    }
                  }).catch((err) => {
                    params.row.loading = false;
                    this.getData();
                    utils.handleError(err);
                  });
                },
              },
            },
            [
              h('span', {
                props: {
                },
                slot: 'open',
              }, '启用'),
              h('span', {
                props: {
                },
                slot: 'close',
              }, '禁用'),
            ]) : h('span', params.row.status === 1 ? '启用' : '禁用');
          },
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', [
            this.handlePermission('roleInfo') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'roleInfo', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('roleEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.showEdit = true;
                  this.toEditId = params.row.id;
                },
              },
            }, '修改') : null,
          ]),

        },
      ],
      tableData: [],
      type: ['总部角色', '门店角色'],
    };
  },
  methods: {
    confirmEdit() {
      this.showEdit = false;
      this.$nextTick(() => {
        this.$router.push({ name: 'roleEdit', params: { id: this.toEditId } });
      });
    },
    createDate() { // 处理时间禁用问题
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.modifiedTime) {
            return time.getTime() > vm.query.modifiedTime;// 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    modifiedDate() {
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.createTime) {
            return time.getTime() < vm.query.createTime;// 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    clear() {
      this.query = {
        name: '',
        createUserName: '',
        createTime: null,
        modifiedTime: null,
      };
    },
    // handleSearch() {
    //   this.page = 1;
    //   this.getData();
    // },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      this.$route.params.create ? this.params.create = true : this.params.create = '';

      system.roleList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.exchangeTime(result.createTime);
            result.modifiedTime = utils.exchangeTime(result.modifiedTime);
            result.type = this.type[result.type - 1];
            result.loading = false;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handlePage(page) {
    //   this.page = page;
    //   this.getData();
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.getData();
    // },
    addNew() {
      this.$router.push({ name: 'roleAdd' });
    },
  },
  mounted() {
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
